var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SvgCircle',{attrs:{"size":_vm.size,"title":_vm.statusTitle,"color":_vm.getStatusColorr(),"verticalAlign":_vm.verticalAlign,"borderColor":_vm.borderColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }